import { Navigate, Outlet } from 'react-router-dom';
import LoginStateManager from '../../core/LoginStateManager';
import Sidebar from '../../components/Sidebar';

const DashboardLayout = () => {
    if (!LoginStateManager.isLoggedIn()) {
        return <Navigate to={'/login'} />;
    }
    return (
        <div className="bg-[#f8f8f8] flex flex-col h-screen w-screen">
            <div className="flex flex-row">
                <Sidebar />
                <div className="flex flex-col">
                    <TopBar />
                    <div className="p-6 w-[calc(100vw-13rem)] max-w-full overflow-x-auto">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DashboardLayout;

const TopBar = () => {
    return (
        <div className="backdrop-blur-md bg-white border-b-[1px] border-gray-200 p-6 w-full h-fit z-10">
            <div></div>
        </div>
    );
};
